module.exports = __webpack_public_path__ + "aa58b84dc401f36f19058fd08ed0f176.glb";